import { AsarButton, AsarFormikInput } from "@/components";
import { Box, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";

function EnterPhone({ submitForm, isSubmitting }) {
  return (
    <>
      <AsarFormikInput
        maxLength={11}
        inputMode="numeric"
        name="phone"
        label="شماره تلفن همراه"
        placeholder={"شماره تلفن همراه خود را بنویسید."}
      />
      <Grid
        display={"flex"}
        flexDirection={"column"}
        width={"100%"}
        sx={{ marginTop: "20px" }}
      >
        <AsarButton disabled={isSubmitting} onClick={submitForm}>
          تایید تلفن همراه
        </AsarButton>
        <Box display="flex" justifyContent="center" mt="20px">
          <Typography sx={{ fontSize: "16px", color: "var(--emr-text-bold)" }}>
            آیا حساب فعالی دارید؟
          </Typography>
          <Link to="/login">
            <Typography
              sx={{
                fontSize: "16px",
                color: "var(--emr-primary)",
                mr: "5px",
                cursor: "pointer",
              }}
            >
              وارد شوید
            </Typography>
          </Link>
        </Box>
      </Grid>
    </>
  );
}

export default EnterPhone;
